import PubSub from "underpub-js";

var CodeEmbed = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-CodeEmbed',
	};

	$.extend(true, this.options, options);

};

CodeEmbed.prototype.init = function() {

	var self = this;

	this.$codeContainer = this.options.$el.find(`.${self.options.baseClass}__code`);
	this.$iframe = this.options.$el.find(`iframe`);

	if (this.$iframe.length) {
		
		let ratio = .5625;
		let width = this.$iframe.attr('width');
		let height = this.$iframe.attr('height');

		if (width && height) {
			ratio = height/width;
		}

		ratio = (ratio * 100) + '%';

		this.$codeContainer.css('padding-bottom', ratio);

	}

};

export default CodeEmbed;
